import React from 'react';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare } from '@fortawesome/free-solid-svg-icons';

const TranslationDoneStatusRenderer: React.FC<ICellRendererParams> = (params) => {
  const status = (params.value || params.data?.status || 'not_done') as string;
  const isDone = status === 'done';
  const color = isDone ? '#43A047' : '#E53935';
  const title = isDone ? 'All translations done' : 'Pending translations';

  return (
    <span title={title} style={{ width: 18 }}>
      <FontAwesomeIcon icon={faSquare} color={color} />
    </span>
  );
};

export default TranslationDoneStatusRenderer;

